// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"b76056ef","703":"bb1d86c5"}[chunkId] + ".chunk.js";
};